import { words } from 'lodash-es'

export default function googleFontLink(fontName) {
  return '//fonts.googleapis.com/css'
    + '?family=' + words(fontName).join('+') + ':400,700'
    + '&display=swap'
}
